import React from 'react';
import { EntitiesCardTitle } from '../../components/entities-card/EntitiesCardTitle';
import { EntitiesTitleLink } from '../../components/entities-card/EntitiesTitleLink';
import { LawFirmIcon } from '../../components/entities-card/icons/LawFirmIcon';

type Props = React.HTMLProps<HTMLAnchorElement>;

export const LawFirmCardTitle: React.FC<Props> = (props) => (
  <EntitiesTitleLink {...props}>
    <EntitiesCardTitle icons={LawFirmIcon}>{props.children}</EntitiesCardTitle>
  </EntitiesTitleLink>
);
